<template>
    <v-container fluid :style="{'background-color':$store.getters.getColorPalette().backgroundColorCode}">
        <v-row>
            <v-col>
                <ProductsTable />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import ProductsTable from '@/components/lists/derived/ProductsTable'
export default {
    name:'ProductsPage',
    components:{
        ProductsTable
    }
}
</script>